'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var _isUrl = require('is-url');

var _isUrl2 = _interopRequireDefault(_isUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isValidUrl = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _isUrl2.default)(value)) return message;
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var isValidEmail = (0, _revalidate.createValidator)(function (message) {
  return function (value) {
    if (!(0, _emailValidator.validate)(value)) {
      return message;
    }
  };
}, function (field) {
  return field + ' doesn\'t seem to be valid';
});

var validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))('Name'),

  developer: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))('Company name'),

  icon: (0, _revalidate.composeValidators)(_revalidate.isRequired, isValidUrl)('Icon'),

  description: (0, _revalidate.composeValidators)(_revalidate.isRequired, (0, _revalidate.hasLengthGreaterThan)(2))('Description')
});

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/createAppFormValidation.js
// module id = 2791
// module chunks = 0